import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';
import AnalyticsOverview from './analytics/AnalyticsOverview';
import AnalyticsFinancial from './analytics/AnalyticsFinancial';
import AnalyticsSupply from './analytics/AnalyticsSupply';
import AnalyticsDemand from './analytics/AnalyticsDemand';
import AnalyticsCards from './analytics/AnalyticsCards';

var Auth = new AuthService();

var TABS = [
  { key: 'overview', label: 'Overview', icon: 'fa-tachometer' },
  { key: 'financial', label: 'Financial', icon: 'fa-dollar' },
  { key: 'supply', label: 'Supply', icon: 'fa-store' },
  { key: 'demand', label: 'Demand', icon: 'fa-users' },
  { key: 'cards', label: 'Cards', icon: 'fa-th-large' },
];

var PERIODS = [
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: '90d', label: '90d' },
  { key: '365d', label: '1y' },
];

class AdminAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview',
      period: '30d',
      data: null,
      loading: true,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handlePeriodChange = this.handlePeriodChange.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData(tab, period) {
    var self = this;
    var activeTab = tab || this.state.activeTab;
    var activePeriod = period || this.state.period;

    self.setState({ loading: true, data: null });

    var url;
    if (activeTab === 'overview') {
      url = constants.DOMAIN + '/api/v1/admin/analytics';
    } else {
      url = constants.DOMAIN + '/api/v1/admin/analytics/' + activeTab + '?period=' + activePeriod;
    }

    Auth.fetch(url)
      .then(function(data) { self.setState({ data: data, loading: false }); })
      .catch(function(err) { console.log('Failed to fetch analytics:', err); self.setState({ loading: false }); });
  }

  handleTabChange(tab) {
    this.setState({ activeTab: tab }, function() { this.fetchData(tab); }.bind(this));
  }

  handlePeriodChange(period) {
    this.setState({ period: period }, function() { this.fetchData(null, period); }.bind(this));
  }

  render() {
    var self = this;
    var activeTab = this.state.activeTab;
    var period = this.state.period;

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6 tw-flex-wrap tw-gap-3">
          <div>
            <h1 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Analytics</h1>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">Platform performance metrics</p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            {/* Period selector (hidden for overview) */}
            {activeTab !== 'overview' && (
              <div className="tw-flex tw-bg-[#f5f5f5] dark:tw-bg-[#222] tw-rounded-lg tw-p-0.5">
                {PERIODS.map(function(p) {
                  var isActive = period === p.key;
                  return (
                    <button
                      key={p.key}
                      onClick={function() { self.handlePeriodChange(p.key); }}
                      className={'tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-border-0 tw-cursor-pointer tw-transition-colors ' +
                        (isActive
                          ? 'tw-text-[#1a1a1a] dark:tw-text-white tw-bg-white dark:tw-bg-[#333] tw-shadow-sm'
                          : 'tw-text-[#999] tw-bg-transparent hover:tw-text-[#666]'
                        )
                      }
                    >
                      {p.label}
                    </button>
                  );
                })}
              </div>
            )}

            <button
              onClick={function() { self.fetchData(); }}
              className="tw-px-3 tw-py-1.5 tw-bg-[#f5f5f5] dark:tw-bg-[#222] tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#eee] dark:hover:tw-bg-[#2a2a2a] tw-transition-colors"
            >
              <i className="fa fa-refresh tw-mr-1.5" /> Refresh
            </button>
          </div>
        </div>

        {/* Tab Bar */}
        <div className="tw-flex tw-gap-1 tw-mb-6 tw-overflow-x-auto tw-pb-1" style={{ WebkitOverflowScrolling: 'touch' }}>
          {TABS.map(function(tab) {
            var isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={function() { self.handleTabChange(tab.key); }}
                className={'tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-transition-colors tw-whitespace-nowrap ' +
                  (isActive
                    ? 'tw-text-[#1a1a1a] dark:tw-text-white'
                    : 'tw-text-[#888] tw-bg-transparent hover:tw-text-[#555] hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]'
                  )
                }
                style={isActive ? { backgroundColor: 'rgba(212,168,67,0.15)' } : {}}
              >
                <i className={'fa ' + tab.icon} style={isActive ? { color: '#D4A843' } : {}} />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Loading */}
        {this.state.loading && (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading analytics...</span>
            </div>
          </div>
        )}

        {/* Tab Content */}
        {!this.state.loading && activeTab === 'overview' && (
          <AnalyticsOverview data={this.state.data} onOpenUserModal={this.props.onOpenUserModal} />
        )}
        {!this.state.loading && activeTab === 'financial' && (
          <AnalyticsFinancial data={this.state.data} />
        )}
        {!this.state.loading && activeTab === 'supply' && (
          <AnalyticsSupply data={this.state.data} />
        )}
        {!this.state.loading && activeTab === 'demand' && (
          <AnalyticsDemand data={this.state.data} onOpenUserModal={this.props.onOpenUserModal} />
        )}
        {!this.state.loading && activeTab === 'cards' && (
          <AnalyticsCards data={this.state.data} />
        )}
      </div>
    );
  }
}

export default AdminAnalytics;
